<template>
  <v-card class="c-card d-flex flex-column">
    <v-skeleton-loader
      v-bind="attrs"
      class="c-content-skeleton pb-4"
      :types="{
        'content-image': 'image',
        'content-metadata': 'button@2',
        'content-action-bar': 'avatar@4'
      }"
      type="
        list-item-avatar-three-line,
        content-image,
        card-heading,
        list-item-three-line,
        content-action-bar
      "
    />
  </v-card>
</template>

<script>
export default {
  name: 'ContentCardSkeleton',

  components: {},

  data: function () {
    return {
      attrs: {
        elevation: 2
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.c-card {
  height: 100%;
  min-width: 275px;
  max-width: min(380px, 100%);
  border-radius: 16px;
}

.c-content-skeleton {
  :deep(.v-skeleton-loader__content-image) {
    margin: 0 16px;
  }

  :deep(.v-skeleton-loader__content-action-bar) {
    margin-top: 8px;
    padding: 0 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  :deep(.v-skeleton-loader__content-metadata) {
    margin-top: 8px;
    padding: 0 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  :deep(.v-skeleton-loader__heading) {
    margin-bottom: 0px;
    padding: 0 16px;
  }
}
</style>
